import {
  useEffect,
  useRef,
  useState
} from 'react'
import { useDispatch } from 'react-redux'
import {
  Box,
  Image,
  Stack,
  Textarea
} from '@chakra-ui/react'
import { motion } from 'framer-motion'
import { COLORS } from 'utils/styles'
import { ImagesPng } from 'assets/images'
import {
  getNotificationMessage,
  postComments,
  putComments
} from 'store'
import {
  PENDING,
  REJECTED,
  SUCCEEDED
} from 'utils/constants'
import { LoadingSpinier } from 'common/Loading'

const MotionStack = motion(Stack)

export const CreateComment = ({
  activeProfile,
  blogParent,
  getCommentsStatus,
  type,
  postCommentsStatus,
  putCommentsStatus,
  editCommentData,
  setEditCommentData
}) => {
  const dispatch = useDispatch()
  const formBodyRef = useRef(null)
  const parentStackRef = useRef(null)
  const [body, setBody] = useState('')
  const [show, setShow] = useState(false)

  const closeForm = () => {
    setBody('')
    setEditCommentData({})
  }

  const submitForm = () => {
    if (body.trim() === '') {
      dispatch(
        getNotificationMessage({
          type: REJECTED,
          message: 'Body field is required',
          isEditProfile: true
        })
      )
    } else if (Object.keys(editCommentData).length === 0) {
      dispatch(postComments({
        id: activeProfile.id,
        type,
        ...(type === 'post' ? { post_id: blogParent[blogParent.length - 1].id } : { comment_id: blogParent[blogParent.length - 1].comment_id }),
        body
      }))
    } else {
      dispatch(putComments({
        id: activeProfile.id,
        type,
        comment_id: editCommentData.comment_id,
        body
      }))
    }
  }

  const focusBodyRef = () => {
    if (formBodyRef.current) {
      formBodyRef.current.blur()
      formBodyRef.current.focus()
    }
  }

  const handleResize = () => {
    if (formBodyRef.current) {
      formBodyRef.current.style.height = '5px'
      formBodyRef.current.style.height = `
        ${formBodyRef.current.scrollHeight}px
      `
    }
  }

  useEffect(() => {
    handleResize()
  }, [body])

  useEffect(() => {
    if (Object.keys(editCommentData).length !== 0) {
      setBody(editCommentData.body)
      focusBodyRef()
    }
  }, [editCommentData])

  useEffect(() => {
    if (postCommentsStatus === SUCCEEDED) {
      closeForm()
    }
  }, [postCommentsStatus])

  useEffect(() => {
    if (putCommentsStatus === SUCCEEDED) {
      closeForm()
    }
  }, [putCommentsStatus])

  useEffect(() => {
    closeForm()
  }, [blogParent])

  useEffect(() => {
    focusBodyRef()

    setTimeout(() => setShow(true), 850)
  }, [])

  return show
    ? (
      <MotionStack
        initial={{ height: 0 }}
        animate={{ height: 'auto' }}
        transition={{
          type: 'tween',
          duration: 0.8
        }}
        ref={parentStackRef}
        transformOrigin="top"
        overflow="hidden"
        background={COLORS.grayGradientTopToBot}
        width="100%"
        border="solid 1px black"
        borderRadius="3px"
        flexShrink={0}
      >
        <Stack
          display="flex"
          alignItems="center"
          justifyContent="flex-start"
          flexDirection="row"
          padding={body.length ? '8px 8px 0 8px' : '8px 8px 12px 8px'}
          transition="0.5s ease"
        >
          <Image
            boxSize="45px"
            objectFit="cover"
            src={activeProfile.profile_picture || ImagesPng.DefaultImage}
            alt="User Image"
            borderRadius="full"
            display="inline-flex"
          />

          <Textarea
            ref={formBodyRef}
            background={COLORS.lighterGray}
            placeholder="Add your comment here"
            width="100%"
            height="43px"
            minHeight="2.8em"
            overflow="hidden"
            resize="none"
            name="blog-body"
            value={body}
            onChange={(e) => setBody(e.target.value)}
          />
        </Stack>
        <Stack
          direction="row"
          justifyContent="flex-end"
          margin="-10.5px 0 0 0"
          fontSize="13px"
          overflow="hidden"
          display="flex"
          padding={body.length ? '8px' : '0'}
          height={body.length ? '47px' : '0'}
          transition="0.5s ease"
        >
          <Box
            borderRadius="full"
            bg={COLORS.gold}
            p="6px 10px"
            data-name="blog-cancel"
            cursor="pointer"
            onClick={() => closeForm()}
            _hover={{ background: COLORS.gold_hover }}
            transition="background 0.3s"
            pointerEvents={putCommentsStatus !== PENDING && postCommentsStatus !== PENDING ? 'auto' : 'none'}
            overflow="hidden"
            display="flex"
            alignItems="center"
          >
            Cancel
          </Box>
          <Box
            borderRadius="full"
            bg={COLORS.gold}
            p="6px 10px"
            data-name="blog-post"
            cursor="pointer"
            _hover={{ background: COLORS.gold_hover }}
            transition="0.3s"
            pointerEvents={
              putCommentsStatus !== PENDING
              && postCommentsStatus !== PENDING
              && getCommentsStatus !== PENDING
                ? 'auto'
                : 'none'
            }
            onClick={() => submitForm()}
            overflow="hidden"
            display={
              putCommentsStatus === PENDING
              || postCommentsStatus === PENDING
                ? 'block'
                : 'flex'
            }
            alignItems="center"
          >
            {
              putCommentsStatus === PENDING
              || postCommentsStatus === PENDING
                ? (
                  <Stack>
                    <LoadingSpinier
                      width="10px"
                      height="10px"
                      marginTop="23px"
                    />
                  </Stack>
                ) : 'Post'
            }
          </Box>
        </Stack>
      </MotionStack>
    ) : ''
}
